import { applyMiddleware, createStore } from "redux";
import cartReducer from "./cart/cartReducer";
import myLogger from "./middleware/myLogger";

const store = createStore(cartReducer, applyMiddleware(myLogger));

export default store;
